import './errorBoundary.scss';

import uniqueId from 'lodash/uniqueId';
import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';
import useRouteStore from '../../store/routeStore/useRouteStore';
import { Button } from '../Button/Button';

const ErrorBoundaryFallback = (): ReactNode => {
  const { t } = useTranslation();
  const { assignLocation } = useRouteStore();

  const redirectToDashboard = (): void => {
    assignLocation('/dashboard/garage');
  };

  return (
    <div className="error-container">
      <div className="error-img">
        <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
      </div>

      <div className="error-text">
        <h1>{t('errorBoundary.title')}</h1>
        <h2>
          <Trans
            components={[<br key={uniqueId('br-')} />]}
            i18nKey={'errorBoundary.subtitle'}
          />
        </h2>
      </div>

      <div>
        <Button onClick={redirectToDashboard}>
          {t('errorBoundary.dashboard')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
